import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXamppComponent } from './simple-icons-xampp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXamppComponent ],
    exports:      [ SimpleIconsXamppComponent ],
    bootstrap:    []
})
export class SimpleIconsXamppModule {}
